module.exports = __webpack_public_path__ + "img/hys-8.d0e1c08f.webp";